import PropTypes from "prop-types"
import React from "react"
import { useMarina } from "src/contexts/MarinaContext"
import Stat from "src/main/Billing/Stat"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const InvoiceStats = ({ invoice }) => {
  const { presentmentCurrency } = useMarina()
  const money = (amount) =>
    formatCurrencyFromMinorUnits({ amount, currency: presentmentCurrency })

  return (
    <section
      aria-label="Invoice summary"
      className="flex flex-col gap-6 border-t border-gray-200 pt-[16px] md:flex-row md:flex-wrap md:gap-x-[60px]"
    >
      <Stat label="Invoice Total">{money(invoice.totalCents)}</Stat>
      <Stat label="Amount Paid">{money(invoice.paidCents)}</Stat>
      <Stat label="Balance Due">{money(invoice.balanceCents)}</Stat>
    </section>
  )
}

InvoiceStats.propTypes = {
  invoice: PropTypes.shape({
    totalCents: PropTypes.number.isRequired,
    paidCents: PropTypes.number.isRequired,
    balanceCents: PropTypes.number.isRequired,
  }).isRequired,
}

export default InvoiceStats
